import * as Yup from "yup";

import { REPORT_ERRORS, REPORT_NAME_MAX_LENGTH, REPORT_PERIOD_CUSTOM, isPeriodWithinLimit } from "entities/reports";

export const buildValidationSchema = (isAdmin: boolean) =>
  Yup.object({
    name: Yup.string().trim().max(REPORT_NAME_MAX_LENGTH),
    level: Yup.string().required(),
    companyId: isAdmin ? Yup.string().trim().required(REPORT_ERRORS.CHOOSE_OPTION) : Yup.string(),
    portfolioId: Yup.string().trim().required(REPORT_ERRORS.CHOOSE_OPTION),
    assetId: Yup.string().when("level", {
      is: "asset",
      then: (schema) => schema.trim().required(REPORT_ERRORS.CHOOSE_OPTION),
      otherwise: (schema) => schema,
    }),
    period: Yup.string().required(REPORT_ERRORS.CHOOSE_OPTION),
    startDate: Yup.string().when("period", {
      is: REPORT_PERIOD_CUSTOM,
      then: (schema) =>
        schema
          .required(REPORT_ERRORS.START_DATE_REQUIRED)
          .test("period-within-limit", REPORT_ERRORS.PERIOD_TOO_LONG, function (value) {
            return isPeriodWithinLimit(value ?? "", (this.parent as { endDate?: string }).endDate ?? "");
          }),
      otherwise: (schema) => schema,
    }),
    endDate: Yup.string().when("period", {
      is: REPORT_PERIOD_CUSTOM,
      then: (schema) => schema.required(REPORT_ERRORS.END_DATE_REQUIRED),
      otherwise: (schema) => schema,
    }),
    format: Yup.string().required(),
  });
